import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { clsx } from 'clsx'

function stripFrontmatter(md: string): string {
  return md.replace(/^---\n[\s\S]*?\n---\n?/, '')
}

export default function MarkdownViewer({ content, className }: { content: string; className?: string }) {
  const body = stripFrontmatter(content)
  return (
    <div className={clsx('prose max-w-none prose-stone', className)}>
      <style>{`
        .prose h1, .prose h2, .prose h3, .prose h4, .prose h5, .prose h6 {
          font-family: 'DM Sans', system-ui, sans-serif;
          font-weight: 700;
          text-transform: none;
          letter-spacing: normal;
          color: #1c1917;
        }
        .prose h2 { font-size: 1.125rem; margin-top: 2rem; margin-bottom: 0.75rem; }
        .prose h3 { font-size: 1rem; margin-top: 1.5rem; margin-bottom: 0.5rem; }
        .prose p { color: #44403c; font-size: 0.9375rem; line-height: 1.65; margin-bottom: 0.75rem; }
        .prose li { color: #44403c; font-size: 0.9375rem; margin-bottom: 0.25rem; }
        .prose strong { color: #1c1917; }
        .prose a { color: #1d6b65; text-decoration: none; }
        .prose a:hover { text-decoration: underline; }
        .prose code { background: #f2f0ed; color: #1d6b65; padding: 0.15em 0.35em; font-size: 0.85rem; border-radius: 4px; }
        .prose pre { background: #f9f8f6; border: 1px solid #e7e5e4; padding: 1rem; border-radius: 8px; overflow-x: auto; }
        .prose pre code { background: none; padding: 0; }
        .prose hr { border-color: #e7e5e4; margin: 2rem 0; }
        .prose blockquote { border-left: 2px solid #1d6b65; padding-left: 1rem; color: #78716c; }
        .prose table { width: 100%; font-size: 0.875rem; }
        .prose th { background: #f2f0ed; color: #44403c; padding: 0.5rem 0.75rem; text-align: left; border-bottom: 1px solid #e7e5e4; font-weight: 600; }
        .prose td { padding: 0.5rem 0.75rem; border-bottom: 1px solid #f2f0ed; color: #44403c; }
      `}</style>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
    </div>
  )
}
